import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import classnames from 'classnames';
import pick from 'lodash/pick';
import omit from 'lodash/omit';
import computeHeights from './_utils/computeTextareaHeights';

var Textarea = function (_React$Component) {
  _inherits(Textarea, _React$Component);

  var _super = _createSuper(Textarea);

  function Textarea(props) {
    var _this;

    _classCallCheck(this, Textarea);

    _this = _super.call(this, props);

    _this.handleChange = function (e) {
      if (_this.props.value === undefined) {
        _this.setState({
          value: e.currentTarget.value
        }, function () {
          _this._resize();
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(e);
      }
    };

    _this._attachRef = function ($$textarea) {
      _this.textareaRef.current = $$textarea;

      if (_this.props.innerRef) {
        if (typeof _this.props.innerRef === 'function') {
          _this.props.innerRef($$textarea);
        } else {
          _this.props.innerRef.current = $$textarea;
        }
      }
    };

    _this._resize = function () {
      var autosize = _this.props.autosize;
      var $$textarea = _this.textareaRef.current;

      if (!autosize || !$$textarea) {
        return;
      }

      if (typeof autosize === 'boolean') {
        autosize = {};
      }

      var _autosize = autosize,
          _autosize$minRows = _autosize.minRows,
          minRows = _autosize$minRows === void 0 ? null : _autosize$minRows,
          _autosize$maxRows = _autosize.maxRows,
          maxRows = _autosize$maxRows === void 0 ? null : _autosize$maxRows;
      var heights = computeHeights($$textarea, minRows, maxRows);

      if (!heights) {
        return;
      }

      var style = _objectSpread(_objectSpread({}, pick(heights, ['height', 'maxHeight', 'minHeight'])), {}, {
        overflowY: 'hidden'
      });

      if (maxRows !== null && heights.rawHeight > heights.maxHeight) {
        style.overflowY = '';
      }

      _this.setState({
        style: style
      });
    };

    var value = '';

    if (props.value !== undefined) {
      var _props$value;

      value = (_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : '';
    } else if (props.defaultValue !== undefined) {
      var _props$defaultValue;

      value = (_props$defaultValue = props.defaultValue) !== null && _props$defaultValue !== void 0 ? _props$defaultValue : '';
    }

    _this.state = {
      value: value,
      style: null
    };
    _this.textareaRef = React.createRef();
    return _this;
  }

  _createClass(Textarea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._resize();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevValue = prevProps.value !== null ? prevProps.value : '';
      var nextValue = this.props.value !== null ? this.props.value : '';

      if (prevValue !== nextValue) {
        this._resize();
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      var $$textarea = this.textareaRef.current;

      if (!$$textarea) {
        return;
      }

      $$textarea.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      var $$textarea = this.textareaRef.current;

      if (!$$textarea) {
        return;
      }

      $$textarea.blur();
    }
  }, {
    key: "select",
    value: function select(start, length) {
      var $$textarea = this.textareaRef.current;

      if (!$$textarea) {
        return;
      }

      $$textarea.focus();

      if (start === undefined) {
        $$textarea.select();
        return;
      }

      if (Number.isNaN(start)) {
        start = 0;
      }

      var totalLength = $$textarea.value.length;

      if (start < 0) {
        start = totalLength - Math.abs(start);

        if (start < 0) {
          start = 0;
        }
      }

      var end = totalLength;

      if (length !== undefined) {
        if (Number.isNaN(length) || length < 0) {
          length = 0;
        }

        end = start + length;
      }

      $$textarea.setSelectionRange(start, end);
    }
  }, {
    key: "render",
    value: function render() {
      var value = this.state.value;
      var _this$props = this.props,
          className = _this$props.className,
          disabled = _this$props.disabled,
          style = _this$props.style;
      var nativeProps = omit(this.props, ['autosize', 'innerRef', 'defaultValue']);

      var _style = _objectSpread(_objectSpread({}, style), this.state.style);

      var _className = classnames(className, 'Textarea', {
        'Textarea--disabled': disabled
      });

      return React.createElement("textarea", Object.assign({}, nativeProps, {
        className: _className,
        style: _style,
        onChange: this.handleChange,
        value: value,
        ref: this._attachRef
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var nextValue = nextProps.value !== null ? nextProps.value : '';

      if (nextValue !== undefined && prevState.value !== nextValue) {
        return {
          value: nextValue
        };
      }

      return null;
    }
  }]);

  return Textarea;
}(React.Component);

Textarea.isFormControl = true;
Textarea.defaultProps = {
  defaultValue: undefined,
  value: undefined,
  autosize: false,
  disabled: false,
  onChange: undefined,
  className: undefined,
  style: undefined,
  innerRef: undefined
};
export default Textarea;